<template>
  <footer class="n-footer">
    <!-- Copyright -->
    <div class="n-footer__footer">
      <div class="container">
        <div class="n-footer__legal">
          <div class="n-footer__copyright" v-html="$t('sayl-oat.copyright', { year })"></div>
          <div class="n-footer__links">
            <ul class="n-footer__list">
              <li
                v-for="item in legal"
                :key="item.label" 
                class="n-footer__item">
                <router-link
                  :to="item.href" 
                  class="n-footer__link">{{ item.label }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'OATFooter',

  data(){
    return {
      email: null,

      legal: [
        { label: this.$t('sayl-oat.terms'), href: {name:'sayl-oat-cms.terms'} },
        { label: this.$t('sayl-oat.privacy'), href: {name:'sayl-oat-cms.privacy'} },
        { label: this.$t('sayl-oat.cookie'), href: {name:'sayl-oat-cms.cookie'} },
      ],
    }
  },

  computed: {
    ...mapState({
      shop: state => state['sayl-oat'].shop,
      user: state => state['sayl-oat'].user
    }),

    logo(){
      return this.shop && this.shop.logo ? this.shop.logo : null;
    },

    year(){
      return new Date().getFullYear()
    }
  },
}
</script>
